import type { DateTimeString, Uuid } from "@/utils"

export enum NotificationType {
  VerifyEmail = "verify_email",
}

export type Notification = {
  readonly id: Uuid
  readonly type: NotificationType
  readonly entityId: Uuid
  readonly text: string
  readonly validAfter: DateTimeString
}

export type EntityLink = {
  type: "dataset"
  id: Uuid
  tenantSlug: string
  label: string
}

export type FlashMessage = {
  variant: "info" | "success" | "warning" | "error"
  message: string
  link: EntityLink | null
}
